import { Empty, Typography } from "antd";
import { useSlicerVariables, useWidgetData } from "../Contexts/dashboardHooks";
import { WidgetInfoButton } from "../Info/WidgetInfoButton";
import { resolveTemplate } from "../Utils/resolveTemplate";

const { Text } = Typography;

export function PlayerNotesWidget({ id }: { id: string }) {
  const data = useWidgetData(id);
  const slicerValues = useSlicerVariables();
  const notes = data?.type === "player_notes" ? data.notes : undefined;
  const spec = data?.type === "player_notes" ? data.spec : undefined;

  if (!notes || !spec) {
    return (
      <div className="player-notes-widget player-notes-empty">
        <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} description="No note configured" />
      </div>
    );
  }

  const label = resolveTemplate(notes.label ?? "", slicerValues).resolved || "Player Notes";

  return (
    <div className="player-notes-widget">
      <div className="widget-header">
        <span style={{ display: "inline-flex", alignItems: "center", gap: 6 }}>
          <Text strong style={{ fontSize: 18 }}>{label}</Text>
          <WidgetInfoButton id={id} />
        </span>
      </div>
      <div className={`player-notes-content ${notes.entries.length > 0 ? "has-entries" : ""}`}>
        {notes.entries.length === 0 ? (
          <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} description="No notes found" />
        ) : (
          notes.entries.map((entry, i) => (
            <div key={i} className="player-notes-preview-entry">
              <div className="player-notes-preview-entry-header">
                <span className="player-notes-header-left">
                  {entry.playerName && (
                    <span className="player-notes-preview-player-badge">{entry.playerName}</span>
                  )}
                  {entry.date && (
                    <span className="player-notes-preview-date-tag">{entry.date}</span>
                  )}
                </span>
                {entry.authorName && (
                  <span className="player-notes-preview-author">{entry.authorName}</span>
                )}
              </div>
              <div className="player-notes-preview-note-text">{entry.text}</div>
            </div>
          ))
        )}
      </div>
    </div>
  );
}
